import { Box } from '@chakra-ui/react';
import PanelCard from '../../../PanelCard';
import { APTAByServiceChart } from './APTAByService';
import { NoiseReductionByServiceChart } from './NoiseReductionByService';
import {
  useGetAnalyticsNoiseReductionByServiceExport,
  useGetAnalyticsAPTAMetricsByServiceExport,
  useGetAnalyticsNoiseReductionByTeamExport,
} from 'views/main/organization/analytics-v3/hooks/useGetAnalyticsData';
import { NoiseReductionByTeamChart } from './NoiseReductionByTeam';
import { useEffect } from 'react';
import { AppTracker } from 'shared/analytics/tracker';
import { ANALYTIC_V3_EVENTS } from 'views/main/organization/analytics-v3/constants';
import { BillingService } from 'core/services';
import { useSelector } from 'react-redux';
import { IAppState } from 'core/interfaces/IAppState';

function NoiseReduction({ isOrgAnalytics = false }: { isOrgAnalytics?: boolean }) {
  const {
    isLoading: isLoadingNoiseReductionByServiceExport,
    refetch: refetchNoiseReductionByServiceExport,
  } = useGetAnalyticsNoiseReductionByServiceExport();
  const {
    isLoading: isLoadingAPTAMetricsByServiceExport,
    refetch: refetchAPTAMetricsByServiceExport,
  } = useGetAnalyticsAPTAMetricsByServiceExport();

  const {
    isLoading: isLoadingNoiseReductionByTeamExport,
    refetch: refetchNoiseReductionByTeamExport,
  } = useGetAnalyticsNoiseReductionByTeamExport();

  const org = useSelector((state: IAppState) => state.organization);

  const isAutoPauseTransientAlertsDisabled = BillingService.isFeatureDisabled(
    { organization: org },
    'auto-pause-transient-alerts',
  );

  useEffect(() => {
    AppTracker.track(ANALYTIC_V3_EVENTS.INCIDENT_ANALYTICS_PAGE_VIEWED, {
      'Analytics Scope': isOrgAnalytics ? 'Organization Analytics' : 'Team Analytics',
      'Analytics Type': 'Incident Analytics',
      'Analytics Tab': 'Alert Noise Reduction',
    });
  }, []);

  const handleExportClick = (chartTitle: string, exportFn: () => void) => {
    AppTracker.track(ANALYTIC_V3_EVENTS.INCIDENT_ANALYTICS_CHART_EXPORT_CLICKED, {
      'Analytics Scope': isOrgAnalytics ? 'Organization Analytics' : 'Team Analytics',
      'Analytics Type': 'Incident Analytics',
      'Analytics Tab': 'Alert Noise Reduction',
      'Chart Title': chartTitle,
    });
    exportFn();
  };

  if (isOrgAnalytics) {
    return (
      <>
        <Box className="row" mt={'18px'}>
          <PanelCard
            title="Noise Reduction by Team"
            onExportClick={() =>
              handleExportClick('Noise Reduction by Team', refetchNoiseReductionByTeamExport)
            }
          >
            <NoiseReductionByTeamChart isOrgAnalytics={isOrgAnalytics} />
          </PanelCard>
        </Box>
      </>
    );
  }

  return (
    <>
      <Box className="row" mt={'18px'}>
        <PanelCard
          title="Noise Reduction by Service"
          onExportClick={() =>
            handleExportClick('Noise Reduction by Service', refetchNoiseReductionByServiceExport)
          }
        >
          <NoiseReductionByServiceChart isOrgAnalytics={isOrgAnalytics} />
        </PanelCard>
      </Box>
      {!isAutoPauseTransientAlertsDisabled && (
        <Box className="row" mt={'18px'}>
          <PanelCard
            title="Transient Alert Metrics by Service"
            onExportClick={() =>
              handleExportClick(
                'Transient Alert Metrics by Service',
                refetchAPTAMetricsByServiceExport,
              )
            }
          >
            <APTAByServiceChart isOrgAnalytics={isOrgAnalytics} />
          </PanelCard>
        </Box>
      )}
    </>
  );
}

export default NoiseReduction;
